import { signOut } from './slice';
import { resetApp } from '@/redux/actions';
import { clearBrowserSession, invalidateSession } from '@/utils/session';
import { AppDispatch } from '@/redux/store';

export const performSignOut =
  (after?: () => void) => (dispatch: AppDispatch) => {
    invalidateSession();
    clearBrowserSession();
    dispatch(signOut());
    dispatch(resetApp());
    after?.();
  };
